 import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BreadcrumbItem, BreadcrumbService } from './breadcrumb.service';
import { IconComponent } from '../icons/icon-reusable';
import { DashboardIcon, type IconDef } from '../icons/icon';

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [CommonModule, RouterModule, IconComponent],
  template: `<div class="flex flex-wrap items-center text-[12px] leading-none mb-1">

  @for (item of displayBreadcrumbs; track item; let last = $last) {
    <span class="inline-flex h-6 items-center align-middle">
      @if (item.icon) {
        <a
          [routerLink]="item.routerLink"
          [queryParams]="item.queryParams ?? null"
          class="items-center justify-center rounded text-slate700 align-middle"
          >
          <app-icon-reusable [icon]="resolveIcon(item.icon)" [size]="14"></app-icon-reusable>
        </a>
      }
      @if (!item.icon && item.routerLink) {
        <a
          [routerLink]="item.routerLink"
          [queryParams]="item.queryParams ?? null"
          class="inline-flex h-6 items-center rounded px-1.5 align-middle transition"
          [ngClass]="last && displayBreadcrumbs.length > 1 ? 'text-orange500' : 'text-slate900 hover:bg-slate100'"
          [style.color]="last && displayBreadcrumbs.length > 1 ? 'var(--secondary-500, #f97316)' : null"
          >
          <span class="inline-flex items-center leading-none">{{ item.label }}</span>
        </a>
      }
      @if (!item.icon && !item.routerLink) {
        <span
          class="inline-flex h-6 items-center rounded px-1.5 align-middle"
          [ngClass]="last && displayBreadcrumbs.length > 1 ? 'text-orange500' : 'text-slate900'"
          [style.color]="last && displayBreadcrumbs.length > 1 ? 'var(--secondary-500, #f97316)' : null"
          >
          <span class="inline-flex items-center leading-none">{{ item.label }}</span>
        </span>
      }
    </span>
    @if (!last) {
      <span
        class="inline-flex h-6 items-center self-center px-0.5 align-middle text-neutral400"
        >
        <svg viewBox="0 0 16 16" class="h-2.5 w-2.5 fill-none stroke-current" stroke-width="1.8">
          <path d="m6 3 4 5-4 5"></path>
        </svg>
      </span>
    }
  }
</div>`,
})
export class BreadcrumbComponent implements OnInit {
  @Input() items: BreadcrumbItem[] | null = null;
  @Input() iconOverride: IconDef | null = null;

  breadcrumbs: BreadcrumbItem[] = [];
  protected readonly dashboardIcon = DashboardIcon;
  protected get breadcrumbIcon(): IconDef {
    return this.iconOverride ?? this.dashboardIcon;
  }

  protected resolveIcon(icon: BreadcrumbItem['icon']): IconDef {
    if (icon && typeof icon === 'object' && 'svg' in icon) {
      return icon;
    }

    return this.breadcrumbIcon;
  }

  protected get displayBreadcrumbs(): BreadcrumbItem[] {
    return this.items ?? this.breadcrumbs;
  }

  constructor(private breadcrumbService: BreadcrumbService) {}

  ngOnInit(): void {
    this.breadcrumbService.breadcrumbs$.subscribe((items) => {
      this.breadcrumbs = items;
    });
  }
}
